<template>
  <div>
    <div class="row mb-4">
      <div
          v-if="profile === 'SUPPLIER'"
          class="col-md col-6 mb-3"
      >
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'sales' })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/sales.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.satVReytinq') }}</h6>
              <p>{{ $t('myCabinetMenu.qeydAlnmSatlarnzVSatnalmalarnQiymtlndirilmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="profile === 'PROCUREMENT'"
          class="col-md col-6 mb-3"
      >
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'purchases' })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/purcahse.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.alVReytinq') }}</h6>
              <p>{{ $t('myCabinetMenu.qeydAlnmAllarnzVTdarklrinQiymtlndirilmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md col-12 mb-3">
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'myRequests', query: { status: 'ALL' } })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/requests.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6 class="f-w-600">
                {{ $t('myCabinetMenu.sorular') }}
              </h6>
              <p>{{ $t('myCabinetMenu.trfinizdnPlatformadaYerldirilmiSorularnIdaretmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="profile !== 'PROCUREMENT' && (isAdmin || companyUserStatus === 'verified')"
          class="col-md mb-3"
      >
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'vendorManagementOutgoingRequests' })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/vendor-reqeusts.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.tdarkMracitlrim') }}</h6>
              <p>{{ $t('myCabinetMenu.tdarkDyrlndirmFormalarnaGndrdiyinizMracitlr') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="profile !== 'PROCUREMENT'"
          class="col-md mb-3"
      >
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'vendorManagementCustomerRequests' })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/customer-requests.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6>
                {{ $t('myCabinetMenu.mtrilriminSorular') }}
                <span class="badge bg-success blink">
                  <img
                      src="@/assets/images/icons/bolt.png"
                      alt="bolt"
                  >
                  {{ $t('myCabinetMenu.yeni') }}
                </span>
              </h6>
              <p>
                {{ $t('myCabinetMenu.tsdiqlnmiTdarksOlduunuzTkilatlarnSorular') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="profile !== 'PROCUREMENT'"
          class="col-md mb-3"
      >
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'myProductsPage' })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/shopping.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6>
                Məhsul və Xidmətlərim
                <span
                    v-if="inquiry"
                    class="badge bg-success blink"
                >
                  <img
                      src="@/assets/images/icons/bolt.png"
                      alt="bolt"
                  >
                  {{ $t('myCabinetMenu.yeni') }}
                </span>
              </h6>
              <p>
                Axtarışlarda məhsul və xidmətlərinizi təklif edin
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
          v-if="profile === 'PROCUREMENT' && (isAdmin || companyUserStatus === 'verified')"
          class="col-md mb-3"
      >
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'vendorManagementDashboard' })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/vendors.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.tdarklrinIdarEdilmsi') }}</h6>
              <p>{{ $t('myCabinetMenu.tdarkDyrlndirmFormalarVTdarklrinIdaredilmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="profile === 'PROCUREMENT' && (isAdmin || companyUserStatus === 'verified')"
          class="col-md mb-3"
      >
        <div
            class="card h-100 mb-0 pointer"
            @click.prevent="$router.push({ name: 'vendorManagementReports' })"
        >
          <div class="card-body cabinet-item">
            <img
                src="../../assets/images/icons/dashboard/reports.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.hesabatlar') }}</h6>
              <p>{{ $t('myCabinetMenu.qiymtSorularVAllarlaBalHesabatlar') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div
          v-if="profile === 'PROCUREMENT'"
          class="col-md mb-3"
      >
        <div
            class="card h-100 mb-0 pointer product-search-card"
            @click.prevent="$router.push({ name: 'productSearch' })"
        >
          <div class="card-body cabinet-item">
            <div class="search-title">
              <h1 class="search-text">
                Sürətli məhsul və xidmət axtarışı
                <i class="fa fa-search search-icon" />
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfileName } from "@/repositories/Utils";
import { mapState } from "vuex";
import { getNewInquiry } from "@/repositories/ProductDataRepository";

export default {
  name: 'MyCabinetMenu',
  props: {
    profile: {},
    requestStatusStatistics: {}
  },
  data() {
    return {
      inquiry: false
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.auth.isAdmin,
      companyUserStatus: state => state.auth.companyUserStatus,
      token: state => state.auth.token,
    })
  },
  mounted() {
    this.hasNewInquiry();
  },
  methods: {
    getProfileName(keyword) {
      return getProfileName(keyword, this.$i18n);
    },
    hasNewInquiry() {
      getNewInquiry(this.token).then(data => {
        if (data.code === 200) {
          this.inquiry = data.hasNewInquiry;
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme/_variables.scss";

.cabinet-item {
  font-size: 14px;
  display: flex;
  align-items: start;
  justify-content: start;

  .cabinet-item-icon {
    width: 50px;
    margin-right: 20px;
  }

  h6 {
    font-size: 16px;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    margin-bottom: 0;
    color: $theme-body-sub-title-color;
  }
}

.product-search-card {
  border: 1px solid rgba(1, 1, 1, 0.1)
}

.search-title {
  display: flex;
  align-items: center;
  justify-content: center; /* Center the content horizontally */
  width: 100%; /* Ensure the container takes the full width */
}

.search-icon {
  font-size: 24px; /* Adjust the icon size */
  margin-left: 10px; /* Space between icon and text */
}

.search-text {
  font-size: 24px; /* Adjust the text size */
  margin: 0; /* Remove margin from h1 */
}
</style>
